import {
  ChangeDetectionStrategy,
  Component,
  input,
  computed,
} from '@angular/core';

import { SmallCard } from 'www-cms';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-small-cards',
  imports: [ImageWithLoaderComponent, ButtonLinkComponent, DirectusDirective],
  templateUrl: './small-card.component.html',
  host: {
    '[class]': `'max-md:flex max-md:flex-col justify-between gap-5 px-8 md:px-16 lg:px-24 xl:px-32 mb-24 md:mt-10' + ' ' + hostClasses()`,
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallCardsComponent extends BaseBuildingBlockComponent {
  smallCardsData = input.required<SmallCard>();

  hostClasses = computed(() =>
    this.smallCardsData().display === 'flex'
      ? 'flex md:flex-row'
      : 'md:grid md:grid-cols-3'
  );

  imageAspectRatio = computed(() =>
    this.smallCardsData().isVertical ? 'aspect-[4/5]' : 'aspect-[4/3]'
  );

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }
}
